export default __webpack_public_path__ + "static/media/store-top2.6f703246.jpg";